module.exports = __webpack_public_path__ + "TRN FAQ.pdf";